module.exports = new Promise((resolve, reject) => {
              const microfrontendsURL = window?.configs?.MICROFRONTENDS_URL || 'http://localhost:3100';
              const baseUrl = microfrontendsURL.replace(/\/$/, '');
              const agenticChatBuild = '';
              const agenticPath = agenticChatBuild ? `/agentic-chat/${agenticChatBuild}` : '/agentic-chat';
              const remoteUrl = baseUrl + agenticPath + '/remoteEntry.js';

              if (window.agentic_chat) {
                resolve(window.agentic_chat);
                return;
              }

              const existingScript = document.querySelector(`script[src="${remoteUrl}"]`);
              if (existingScript) {
                const checkExisting = (attempts = 0) => {
                  if (window.agentic_chat) {
                    resolve(window.agentic_chat);
                  } else if (attempts < 50) {
                    setTimeout(() => checkExisting(attempts + 1), 100);
                  } else {
                    reject(new Error('agentic_chat container not available after 5s'));
                  }
                };
                checkExisting();
                return;
              }

              const script = document.createElement('script');
              script.src = remoteUrl;
              script.type = 'text/javascript';
              script.async = true;

              script.onload = () => {
                const checkContainer = (attempts = 0) => {
                  if (window.agentic_chat) {
                    resolve(window.agentic_chat);
                  } else if (attempts < 50) {
                    setTimeout(() => checkContainer(attempts + 1), 100);
                  } else {
                    console.error('[Module Federation] agentic_chat container not found after 5s. window.agentic_chat =', window.agentic_chat);
                    reject(new Error('agentic_chat container not available after 5s'));
                  }
                };
                checkContainer();
              };

              script.onerror = () => {
                console.error('[Module Federation] Failed to load agentic_chat from', remoteUrl);
                reject(new Error(`Failed to load agentic-chat from ${remoteUrl}`));
              };

              document.head.appendChild(script);
            });